// externals
import styled from 'styled-components';

// libraries
import { BreakPoint } from '@makemydeal/dr-activities-common';

export const StyledSectionHeader = styled.div`
    margin-bottom: 0.75rem;
`;

export const StyledCardList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
`;

export const StyledCardHeadline = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.5rem;
    margin-bottom: 0.5rem;

    /*
     * Interstate Typography renders block-level, so without this the headline claims the full row
     * width and pushes the badges onto their own lines, making the card noticeably taller than the
     * design. Keeping every child at its natural width holds the vehicle and its badges on one row.
     */
    > * {
        flex: 0 0 auto;
        margin: 0;
    }
`;

export const StyledFieldRow = styled.div`
    display: grid;
    grid-template-columns: repeat(7, minmax(0, 1fr));
    column-gap: 1rem;
    row-gap: 0.75rem;

    @media (max-width: ${BreakPoint.SMALL}) {
        grid-template-columns: repeat(4, minmax(0, 1fr));
    }
`;

export const StyledField = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.125rem;
    min-width: 0;

    /* Typography ships default block margins; they would double the row height here. */
    > * {
        margin: 0;
    }
`;

export const StyledMessage = styled.div`
    padding: 1rem 0;
`;

/** The muted "taking longer" hint. No border/background/icon — it must not read as an error. */
export const StyledSecondaryNote = styled.div`
    margin-top: 0.75rem;

    /* Typography ships default block margins that would double the gap above. */
    > * {
        margin: 0;
    }
`;

/** Same treatment, spaced for a line ABOVE the content — the "retrieving" line above the skeleton. */
export const StyledLeadingNote = styled.div`
    margin-bottom: 0.75rem;

    > * {
        margin: 0;
    }
`;
